module Meevo.Components.Controls {

    export interface DiscountPriceListItem {
        discountAmount: number;
        displayName: string;
        isDefault?: boolean;
        priceGroupId: string;
    }

    export interface DiscountMarketModalOptions {
        data: DiscountPriceListItem[];
        displayName: string;
        discountId: string;
        isPercent: boolean;
    }

    export class DiscountMarketsController {
        static $inject = [
            "meevo.AppSettings",
            "$mdDialog",
            "meevo.components.common.DataService",
            "options",
            "meevo.components.modal.ModalService",
            "meevo.components.common.SecurityService",
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private $mdDialog: angular.material.IDialogService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private options: DiscountMarketModalOptions,
            private modalService: Meevo.Components.Modal.IModalService,
            private securityService: Meevo.Components.Common.ISecurityService) {
        }

        isPriceEditDisabled: boolean = true;

        securityKeys = Meevo.Components.Common.SecurityKeys;
        securityParts = Meevo.Components.Common.SecurityParts;

        $onInit() {
            this.securityService.checkSecurityItem(this.securityKeys.MANAGEMENT_MARKETPRICING_TAB_DISCOUNTS + this.securityParts.KEY_PART_WRITE).then(result => {
                this.isPriceEditDisabled = result.securityAccess != Model.SecurityAccessEnum.Grant;
            });
        }

        closeModal(e): void {
            if (e) e.stopPropagation();

            this.$mdDialog.hide();
        }

        /** The CO/default market's amount as it currently stands in the modal, since Save writes every market at once. */
        get defaultDiscountAmount(): number {
            const defaultMarket = this.options.data.find((item) => item.isDefault);

            return defaultMarket ? defaultMarket.discountAmount : null;
        }

        showRevertToDefault(market: DiscountPriceListItem): boolean {
            return !market.isDefault
                && Model.Guard.isSomething(this.defaultDiscountAmount, false)
                && market.discountAmount != this.defaultDiscountAmount;
        }

        revertToDefault(market: DiscountPriceListItem): void {
            market.discountAmount = this.defaultDiscountAmount;
        }

        applyChanges(e): void {
            if (e) e.stopPropagation();

            this.modalService.yellowConfirm('MESSAGE_PRICE_MANAGEMENT_SAVE_CHANGES', Meevo.Components.Modal.ModalTranslationModes.Translate, true)
                .then((res: boolean) => {

                    if (res !== true)
                        return;

                    this.updateItemPriceOverrides();
                });
        }

        updateItemPriceOverrides() {
            this.dataService.customMethodData("api/Discount/" + this.options.discountId + "/MarketPricing/", "PUT", {
                values: this.options.data.map(row => {
                    return {
                        priceGroupId: row.priceGroupId,
                        discountAmount: row.discountAmount
                    }
                })
            }).then(() => {
                this.closeModalWithValue();
            }).catch(() => {
                /* The exception interceptor already shows the validation message; leave the modal open with the edits. */
            });
        }

        closeModalWithValue() {
            const defaultMarket = this.options.data.find((item) => item.isDefault)

            this.$mdDialog.hide({
                defaultMarket
            });
        }
    }

    angular.module("meevo.components.controls")
        .controller("meevo.components.controls.discountMarkets.DiscountMarketsController", DiscountMarketsController);
}